var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#DC5F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.414L8.586 16l4-4-4-4L10 6.586l4.707 4.707a.999.999 0 010 1.414L10 17.414z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHJ4PSIyIiBmaWxsPSIjREM1RjFGIiAvPgogICAgPHBhdGggZD0iTTEwIDE3LjQxNEw4LjU4NiAxNmw0LTQtNC00TDEwIDYuNTg2bDQuNzA3IDQuNzA3YS45OTkuOTk5IDAgMDEwIDEuNDE0TDEwIDE3LjQxNHoiIGZpbGw9IiNmZmYiIC8+PC9zdmc+";
export { SvgArrowOrange as ReactComponent };